import { render, staticRenderFns } from "./OrderViewActionCancelAndEdit.vue?vue&type=template&id=22f7bd8e&"
import script from "./OrderViewActionCancelAndEdit.vue?vue&type=script&lang=js&"
export * from "./OrderViewActionCancelAndEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports